import Axios, { REQUEST_METHOD } from "../axios";



// to do for protected branches and notifications check
export function apiRemoveMemberWallet(sourceId) {
  return Axios.fetch({
    url: `/wallet/remove-member-wallet/${sourceId}`,
    method: REQUEST_METHOD.DELETE,
  });
}

/**
 * Retrieves the wallet for a given source (user) id.
 * @param {string} sourceId - The unique identifier of the member.
 * @returns {Promise} Axios promise that resolves to the wallet data.
 */
export function apiGetWallet(sourceId) {
  return Axios.fetch({
    url: `/wallet/fetchMemberWallet/${sourceId}`,
    method: REQUEST_METHOD.GET,
    params: {
      sourceId,
    },
  });
}

/**
 * Updates the wallet for a given source (user) id.
 * Only the fields that differ from the current values will be updated.
 * @param {string} sourceId - The unique identifier of the member.
 * @param {Object} updateData - The data fields to update.
 * @returns {Promise} Axios promise that resolves to the updated wallet.
 */
export function apiNewMemberWallet(sourceId, updateData, checksum) {
  return Axios.fetch({
    url: `/wallet/newMemberWallet/${sourceId}`,
    method: REQUEST_METHOD.PUT,
    data: updateData,
    headers: {
      "x-checksum": checksum, // server expects a checksum in the request header giving an extra layer with the custom header to make sure the data is not tampered.
    },
  });
}

// protected branches and checks notifications

export default {
  apiRemoveMemberWallet,
  apiGetWallet,
  apiNewMemberWallet,
};
